if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    //rf form
    if(window.location.pathname === '/account/register'){
      const company_field = document.querySelector('input[name="company-field"]');
      const custom_fields = document.querySelectorAll('#bss-b2b-registration-form-render .form-group');
      if(custom_fields.length){
        custom_fields.forEach(item => {
          const input = item.querySelector("input, textarea");
          const label = item.querySelector("label");
          if(input && label){
            input.placeholder = label.textContent;
          }
        })
      }
      if(company_field){
        company_field.disabled = false;
      }
    }
  }, 300)

  // setTimeout(()=>{
  //   const isPDP = window.location.pathname.includes("/products/");
  //   if (isPDP) {
  //       let oldHref = location.href;
  //       new MutationObserver(() => {
  //           if (oldHref !== location.href) {
  //               oldHref = location.href;
  //               const variant = new URL(location.href).searchParams.get('variant');
  //               setTimeout(() => {
  //                   const productForm = document.querySelector("[bss-b2b-main-product-form]");
  //                   BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
  //                       productForm
  //                   });
  //               }, 600)
  //           }
  //       }).observe(document, {
  //           subtree: true,
  //           childList: true
  //       });
  //   } 

  //   document.addEventListener("click", e => {
  //     const path = e.composedPath();
  //     const selectorCheckout = `.AOV-CDMinimal__CheckoutButton, [name="checkout"], .upcart-checkout-button`;
  //     const target = path.find(el => {
  //       return el?.matches?.(selectorCheckout);
  //     });
  //     if ((e.target && e.target.closest(selectorCheckout)) || target) {
  //         e.preventDefault();
  //         e.stopPropagation();
  //         e.stopImmediatePropagation();
  //         BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
  //     }
  //   }, 1); 

  // }, 3000)
}